"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
exports.default = (function () { return (cache_1.getCache('basename') ? cache_1.getCache('basename') : '/'); });
